import React, { useEffect, useState } from "react";
import InsightTable from "../../InsightTable";
import {
  formatBoldText,
  transformResultsToCompProfileData,
} from "../../../../../services/commonService";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function InboundLogistics({ inboundLogistics = [], compView }) {
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");

  const [columns, setColumns] = useState([]);
  const [sidebarColumns, setSidebarColumns] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);

  let allMetrics = [];
  useEffect(() => {
    if (compView === "quantitative") {
      allMetrics = [
        { key: "share_pct", label: "Share (%)" },
        { key: "avg_lead_time_days", label: "Avg. Lead Time (Days)" },
        { key: "cost_per_ton_mile_usd", label: "Cost per Ton-Mile (USD)" },
        { key: "reliability_risk", label: "Reliability Risk" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    } else {
      allMetrics = [
        { key: "share_pct", label: "Share (%)" },
        { key: "key_routes", label: "Key Routes" },
        { key: "avg_lead_time_days", label: "Avg. Lead Time (Days)" },
        { key: "cost_per_ton_mile_usd", label: "Cost per Ton-Mile (USD)" },
        { key: "reliability_risk", label: "Reliability Risk" },
        { key: "strategic_significance", label: "Strategic Significance" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    }
  }, [compView]);

  useEffect(() => {
    const transformed = transformResultsToCompProfileData(inboundLogistics);
    setTabData(transformed);
    setTableBelowDescription(
      <ParsedTextWithLinks
        text={inboundLogistics?.[0]?.response?.tableComments || ""}
      />
    );
  }, [inboundLogistics]);

  const actions = [
    // { type: "conversation", title: "Conversation", onClick: () => {} },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <InsightTable
      title="Inbound Logistics"
      subtitle=""
      data={tabData}
      metrics={columns}
      rowIdentifier="mode"
      // belowTableDescription={tableBelowDescription}
      belowTableDescription={""}
      actions={actions}
    />
  );
}

export default InboundLogistics;
